import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { PromoId} from "../promo-id.model";
import { promoIdZodSchema } from "../promo-id.model";

type RemovePromoCommand = {
    readonly _id: string;
    readonly _type: "REMOVE_PROMO_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly promoId: PromoId;
};

type FactoryParams = Except<RemovePromoCommand, "_id" | "_createdAt" | "_type">;
const removePromoCommandFactory = (
    params: FactoryParams,
): RemovePromoCommand => {
    return {
        _id: generateId({ prefix: "remove_promo_command__" }),
        _createdAt: nowIsoAndUnix(),
        _type: "REMOVE_PROMO_COMMAND",
        promoId: params.promoId,
    };
};

const removePromoCommandZodSchema: z.ZodSchema<RemovePromoCommand> = z.object({
    _id: idZodSchema,
    _type: z.literal("REMOVE_PROMO_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    promoId: promoIdZodSchema,
});

export {
    removePromoCommandFactory as createRemovePromoCommand,
    removePromoCommandZodSchema,
};
export type { RemovePromoCommand };
